import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import MineJobDetails from "./MineJobDetails";
import MineJobAllProposals from "./MineJobAllProposals";
import MineJobShortlisted from "./MineJobShortlisted";
import { useNavigate, useParams } from "react-router-dom";
import { getPostsById, getPostsCancelById } from "../../../../../../../redux/posts/action";
import { useDispatch, useSelector } from "react-redux";
import { useRouteBaseStateContext } from "../../../../../../../Context/RouteBaseStateContext";
import { decodeHtml } from "../../../../../../../assests/extention/commonfunction";

export default function MineJobDetailsTabs() {
  const { urlstate, setMyorderRecentjobsroute } = useRouteBaseStateContext();
  const { id } = useParams();
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("JobDetails");

  const posts = useSelector(({ posts: { postbyid } }) => postbyid);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (urlstate?.myorderrecentjobsroute) {
      setActiveTab(urlstate?.myorderrecentjobsroute || "JobDetails");
    } else {
      setActiveTab("JobDetails");
    }
  }, [urlstate, urlstate?.myorderrecentjobsroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyorderRecentjobsroute(tab);
  };

  const proposalcount = posts?.proposal || [];
  const wishlistproposalcount =
    posts?.proposal?.filter((item) => item.wishlist == 1) || [];

  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate()

  const directpayment = (item) => {
    const state = {
      id: item?.id,
      type: 3,
      type_of_post: "job",
      post_id: posts?.id,
      post_price: item?.first_amount,
    };
    navigate(`/${lan}/account/paymentmethodpage`, { state: { orderdetails: state } });
  }

  const cancelpost = () => {
    const data = {
      "post_id": posts?.id,
      "type": "3",
      "status": "24"
    }
    dispatch(getPostsCancelById(data))
  }
  return (
    <div className="project-section">
      <h4>{decodeHtml(posts?.title)}</h4>
      <div className="col-12 mob-pad">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "JobDetails" ? "active" : ""}`}
              onClick={() => handleTabClick("JobDetails")}
            >
              Job Details
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "AllProposals" ? "active" : ""}`}
              onClick={() => handleTabClick("AllProposals")}
            >
              {posts?.direct_hiring != 1 ? `All Proposals (${proposalcount.length})` : `Sent Offers`}
            </a>
          </li>
          {posts?.direct_hiring == 1 ? <></> : (
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab == "Shortlisted" ? "active" : ""}`}
                onClick={() => handleTabClick("Shortlisted")}
              >
                Shortlisted ({wishlistproposalcount.length})
              </a>
            </li>
          )}
        </ul>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "JobDetails" ? "active" : ""}`}
            id="JobDetails"
          >
            <MineJobDetails proposalcount={proposalcount} posts={posts} cancelpost={cancelpost} />
          </div>
          <div
            className={`tab-pane ${activeTab == "AllProposals" ? "active" : ""}`}
            id="AllProposals"
          >
            <MineJobAllProposals posts={posts} directpayment={directpayment} />
          </div>
          {posts?.direct_hiring == 1 ? <></> : (
            <div
              className={`tab-pane ${activeTab == "Shortlisted" ? "active" : ""}`}
              id="Shortlisted"
            >
              <MineJobShortlisted posts={posts} directpayment={directpayment} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
